export default {"src":"/_next/static/media/33-icon.0be1673c.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};